import { render, staticRenderFns } from "./updatemodal.vue?vue&type=template&id=3dab066c&scoped=true&"
import script from "./updatemodal.vue?vue&type=script&lang=js&"
export * from "./updatemodal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dab066c",
  null
  
)

export default component.exports